import { BehaviorSubject, interval } from "rxjs";
import {
  distinctUntilChanged,
  groupBy,
  mergeMap,
  pluck,
  sample,
} from "rxjs/operators";

// import { setCamera } from "../../threeSlice";

class StateManager {
  constructor(world) {
    this.world = world;
    this.store = world.store;
    this.state$ = new BehaviorSubject(this.store.getState());
    this.presenter$ = this.state$.pipe(
      pluck("room", "presenter"),
      distinctUntilChanged()
    );
    this.participantId$ = this.state$.pipe(
      pluck("room", "participantId"),
      distinctUntilChanged()
    );
    this.hover$ = this.state$.pipe(
      pluck("three", "hover"),
      distinctUntilChanged()
    );    

    this.entity$ = this.createEntity$();
    this.modelDefinition$ = this.createModelDefinition$();
    this.materialDefinition$ = this.createMaterialDefinition$();
    this.textureDefinition$ = this.createTextureDefinition$();
    
    this.unsubscribeStore = this.store.subscribe(() => {
      this.state$.next(this.store.getState());
    });

    this.unsubscribeEntity$ = this.entity$.subscribe((definition) => {
      this.world.entityManager.setEntity(definition.id, definition);
    }); 

    this.unsubscribeModelDefinition$ = this.modelDefinition$.subscribe(
      (definition) => {
        this.world.modelManager.setModelDefinition(definition.id, definition);
      }
    );

    this.unsubscribeTextureDefinition$ = this.textureDefinition$.subscribe(
      (definition) => {
        this.world.textureManager.setTextureDefinition(
          definition.id,
          definition
        );
      }
    );

    // Submit camera changes
    world.camera$.pipe(sample(interval(250))).subscribe((value) => {
      // world.store.dispatch(setCamera(value));
    });
  }

  createEntity$() {
    return this.state$.pipe(
      pluck("three", "entities"),
      distinctUntilChanged(),
      // TODO: remove entity stream
      mergeMap((definitions) => definitions),

      groupBy(
        (definition) => definition.id,
        (definition) => definition
      ),
      mergeMap((group$) => group$.pipe(distinctUntilChanged()))
    );
  }

  createModelDefinition$() {
    return this.state$.pipe(
      pluck("three", "models"),
      distinctUntilChanged(),
      // TODO: remove entity stream
      mergeMap((definitions) => definitions),
      groupBy(
        (definition) => definition.id,
        (definition) => definition
      ),
      mergeMap((group$) => group$.pipe(distinctUntilChanged()))
    );
  }

  createMaterialDefinition$() {
    return this.state$.pipe(
      pluck("three", "materials"),
      distinctUntilChanged(),
      // TODO: remove entity stream
      mergeMap((definitions) => definitions),
      groupBy(
        (definition) => definition.id,
        (definition) => definition
      ),
      mergeMap((group$) => group$.pipe(distinctUntilChanged()))
    );
  }

  createTextureDefinition$() {
    return this.state$.pipe(
      pluck("three", "textures"),
      distinctUntilChanged(),
      // TODO: remove entity stream
      mergeMap((definitions) => definitions),
      groupBy(
        (definition) => definition.id,
        (definition) => definition
      ),
      mergeMap((group$) => group$.pipe(distinctUntilChanged()))
    );
  }
}

export default StateManager;
